import { createSlice } from "@reduxjs/toolkit";
import { personalgoalState } from "./personalgoalTypes";
import {
    createpersonalgoal
} from "./personalgoalAction"



const initialState: personalgoalState = {
  personalgoal: [],
  selectedpersonalgoal: undefined,
  loadingStates: {
    create: false,
    update: false,
    delete: false,
    fetchById: false,
    fetchAll: false,
  },
  errors: {
    create: undefined,
    update: undefined,
    delete: undefined,
    fetchById: undefined,
    fetchAll: undefined,
  },
};

const personalgoalSlice = createSlice({
  name: "personalgoal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
    //   .addCase(fetchachievemnetById.pending, (state) => {
    //     state.loadingStates.fetchById = true;
    //     state.errors.fetchById = undefined;
    //   })
    //   .addCase(fetchachievemnetById.fulfilled, (state, action) => {
    //     state.loadingStates.fetchById = false;
    //     state.selectedachievement = action.payload;
    //   })
    //   .addCase(fetchachievemnetById.rejected, (state, action) => {
    //     state.loadingStates.fetchById = false;
    //     state.errors.fetchById = action.payload as string;
    //   })
      
    .addCase(createpersonalgoal.pending, (state) => {
                                       state.loadingStates.create = true;
                                       state.errors.create = undefined;
                                 })
                                   .addCase(createpersonalgoal.fulfilled, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.personalgoal.push(action.payload);
                                   })
                                   .addCase(createpersonalgoal.rejected, (state, action) => {
                                       state.loadingStates.create = false;
                                       state.errors.create = action.payload as string;
                                   })
  },
});

export default personalgoalSlice.reducer;